export default __webpack_public_path__ + "assets/images/fe02c9d26d5a104364849d798c18ee64.svg";